export const BRANDMANAGER_URL = '/brandmanager';

export const getBrandmanagerURL = (pageSlug: string) => {
  if (!pageSlug) return BRANDMANAGER_URL;

  return `${BRANDMANAGER_URL}/${pageSlug}/admin`;
};
